/**
 * DEMO strip — rendered only in demo builds (`vite build --mode demo`, which the
 * branch-deploy workflow runs and which loads .env.demo).
 *
 * It sits in NORMAL FLOW rather than fixed/absolute, so it can never overlap the
 * sticky share bar or a screen header; it just pushes the app down by ~22px.
 *
 * The demo runs against the isolated STAGING project — fake dealers, its own
 * database. The strip marks which branch is deployed. Tab title gets [DEMO].
 */
import { useEffect } from 'react';

/** True in branch/preview builds. Production builds set VITE_APP_ENV=production. */
export const IS_DEMO = import.meta.env.VITE_APP_ENV === 'demo';

export function DemoBanner(): JSX.Element | null {
  useEffect(() => {
    if (IS_DEMO && !document.title.startsWith('[DEMO]')) {
      document.title = `[DEMO] ${document.title}`;
    }
  }, []);

  if (!IS_DEMO) return null;

  return (
    <div
      className="flex shrink-0 items-center justify-center gap-1.5 bg-amber-400 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-amber-950"
      role="status"
    >
      <span aria-hidden>⚠</span>
      Demo build · separate demo data · nothing here is real
      {import.meta.env.VITE_DEMO_REF ? (
        <span className="rounded bg-amber-950/15 px-1 py-0.5 font-mono normal-case tracking-normal">
          {import.meta.env.VITE_DEMO_REF}
        </span>
      ) : null}
    </div>
  );
}
